import { render, staticRenderFns } from "./lista-buscador-seleccion-etiquetas-envio.vue?vue&type=template&id=0a7b5482&scoped=true&"
import script from "./lista-buscador-seleccion-etiquetas-envio.vue?vue&type=script&lang=ts&"
export * from "./lista-buscador-seleccion-etiquetas-envio.vue?vue&type=script&lang=ts&"
import style0 from "./lista-buscador-seleccion-etiquetas-envio.vue?vue&type=style&index=0&id=0a7b5482&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a7b5482",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
